import React, { useEffect, useState } from "react";

import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";

export default function ItemTab(props) {
  const [value, setValue] = useState(props.list[0]);
  const [Link, setLink] = useState(
    window.location.href.replace(/^(https?:\/\/)?(www\.)?/i, "")
  );
  const handleChange = (event, newValue) => {
    props.onChange(newValue);
    setValue(newValue);
  };
  useEffect(() => {
    let newCurrent = window.location.href.replace(/^https?:\/\/(www\.)?/, "");
    console.log("currentUrl2", newCurrent, newCurrent.split("/"));
    if (newCurrent.split("/")[3]) {
      let newValue = newCurrent.split("/")[3];
      if (newValue === "mentors") {
        setValue(props.list[0]);
      } else if (newValue === "alumni") {
        setValue(props.list[1]);
      } else if (newValue === "scholars") {
        setValue(props.list[2]);
      } else {
        setValue(props.list[0]);
      }
    } else {
      setValue(props.list[0]);
    }
    // const cleanedUrl = currentUrl.replace(/^http?:\/\/(www\.)?/, "");
    setLink(newCurrent);
  }, []);
  useEffect(() => {
    const handleUrlChange = () => {
      let url = window.location.href.replace(/^https?:\/\/(www\.)?/, "");
      if (url.split("/")[3]) {
        let newValue = url.split("/")[3];
        if (newValue === "mentors") {
          setValue(props.list[0]);
        } else if (newValue === "alumni") {
          setValue(props.list[1]);
        } else {
          setValue(props.list[2]);
        }
      } else {
        setValue(props.list[0]);
      }
      setLink(url);
    };

    // Add event listener for popstate (back/forward navigation)
    window.addEventListener("popstate", handleUrlChange);

    // Optionally, you can add event listeners for pushState and replaceState if you're using those
    const originalPushState = window.history.pushState;
    const originalReplaceState = window.history.replaceState;

    window.history.pushState = function (...args) {
      originalPushState.apply(this, args);
      handleUrlChange();
    };

    window.history.replaceState = function (...args) {
      originalReplaceState.apply(this, args);
      handleUrlChange();
    };

    // Clean up event listeners on component unmount
    return () => {
      window.removeEventListener("popstate", handleUrlChange);
      window.history.pushState = originalPushState;
      window.history.replaceState = originalReplaceState;
    };
  }, []);
  console.log("in tab links", Link);
  return (
    <Box sx={{ width: "100%" }}>
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs
          value={value}
          onChange={handleChange}
          textColor="secondary"
          indicatorColor="secondary"
          aria-label="secondary tabs example"
        >
          {props.list.map((item, index) => {
            return <Tab value={item} label={item} />;
          })}
          {/* <Tab value="two" label="Item Two" />
          <Tab value="three" label="Item Three" /> */}
        </Tabs>
      </Box>
    </Box>
  );
}
